//smcm = 'S'how 'M'ore 'C'ontent 'M'arker
function showSmcms() {
    var cid = $(this).attr('catid');
    $("ul[catid='" + cid + "'] li.smcm").show();
    $(this).parent().find('.smcmLinkLess').show();
    $(this).hide();
}

function hideSmcms() {
    var cid = $(this).attr('catid');
    $("ul[catid='" + cid + "'] li.smcm").hide();
    $(this).parent().find('.smcmLinkMore').show();
    $(this).hide();
}

export function initrecipe() {

    let intervalId = 0;
    if ($(".recipe-image-select li").length > 1) {
        intervalId = setInterval(initRecipeSlider, 3000);
    } else {
        $("#up, #down").remove();
    }
    $(".recipe-image-select--down").on("click", function (e) {
        e.preventDefault();
        clearInterval(intervalId);
        initRecipeSlider();
    });
    $(".recipe-image-select--up").on("click", function (e) {
        e.preventDefault();
        clearInterval(intervalId);
        initRecipeSlider(true);
    });

    function initRecipeSlider(isUp = false) {
        if (!$(".recipe-image-select").hasClass("running")) {
            let height = $(".recipe-image-select li").first().height();
            $("#slideshow").css("--imageHeight", height + "px");
            $("#slideshow").css("height", $("#slideshow").height());
            $(".recipe-image-select").addClass("running");
            if (isUp) {
                let temp = $(".recipe-image-select li").last().clone();
                $(".recipe-image-select").addClass("animateUp");
                $(".recipe-image-select ul").prepend(temp);
            } else {
                let temp = $(".recipe-image-select li").first().clone();
                $(".recipe-image-select").addClass("animateDown");
                $(".recipe-image-select ul").append(temp);
            }
        }
    }

    $("#slideshow").on("animationend", function (event) {
        if (event.originalEvent.animationName == "animateUp") {
            $(".recipe-image-select li").last().remove();
            $(".recipe-image-select").removeClass("animateUp");
        } else if (event.originalEvent.animationName == "animateDown") {
            $(".recipe-image-select li").first().remove();
            $(".recipe-image-select").removeClass("animateDown");
        }
        $("#recipedetail-image-full").attr("src", $(".recipe-image-select li").first().find("img").attr("data-full"));
        $(".recipe-image-select").removeClass("running");
        $("#slideshow").css("height", "");
    })
    $(".recipe-image-select").on("click", function (event) {
        clearInterval(intervalId);
        $("#recipedetail-image-full").attr("src", $(event.target).attr("data-full"));
    });

    //Ausblenden leerer Filterboxen (Aus Performancegruenden nicht per XSL!)
    var anyfiltr = false;
    $('#filterboxes .filtrbox').each(function (index) {
        if ($(this).find(".filtrboxcontent li").length <= 0) {
            $(this).remove();
        } else {
            anyfiltr = true;
        }
    });
    if (!anyfiltr) {
        $("#filterboxes").empty();
    }
    var buton = $('.smcmLinkMore');
    buton.on('click', showSmcms);
    var butonL = $('.smcmLinkLess');
    butonL.on('click', hideSmcms);
    butonL.trigger('click');
    //Rating Hover
    $('#portionsset .icon-star.changeable').on({
        'mouseover': function () {
            $(this).prevAll('.icon-star').addClass('on');
        },
        'mouseout': function () {
            $(this).prevAll('.icon-star').removeClass('on');
        }
    });
    $('#filterboxes .recipe-sa input:checkbox').on('click', function () {
        $(this).closest('form').submit();
        $(this).closest('form').find('input:checkbox').attr('disabled', 'disabled');
    });


    $(".tablist a").on("click", function () {
        setTimeout(function () {
            // Do something after 5 seconds
            $('.module').each(function (index) {
                $(this).find('.element').responsiveEqualHeightGrid();
            });
            //$('.wine-con').responsiveEqualHeightGrid();
        }, 5);

    });


    $(".swap-content:first").show();
    $('.swap-tab-nav li:first a').addClass('active');
    $('.swap-tab-nav li a').on('click', function () {
        $('.swap-tab-nav li a.active').removeClass("active");
        $(this).addClass('active');
        var activeTab = $(this).attr("rel");
        $(this).closest('.swap-ingredients').find('.swap-content').hide();
        $(activeTab).show();
    });
    $('.swap-ingredients .tab-wrapper a.close-tab').on('click', function () {
        $(this).closest('.swap-ingredients').hide();
        $(this).closest('.swap-ingredients').prev('p').show();
    });
    $('.has-alternative').on('click', function () {
        $(this).closest('.ingredients').next('p').hide();
        $(this).closest('.module-content').find('.swap-ingredients').show();

    });

    //** Nutritional Values Styling *//
    $(document).ready(function () {
        $("#nutritional_value table").each(function () {
            if ($(this).hasClass('single')) {
                $(this).find("col").css('border', 'none');
            }
            else {
                $(this).find("col:first").css({
                    'background': 'none repeat scroll 0 0 rgba(31, 76, 152, 0.08)',
                    'border-left': 'none'
                });
                $(this).find("col:last").css('border-right', 'none');
            }
            $(this).find('tr:nth-child(even)').addClass('even');

        });
        $("#nutritional_value .col-lg-6:first").css('padding-right', '0.75%');
        $("#nutritional_value .col-lg-6:last").css('padding-left', '0.75%');
    });

    //Togglebox
    $(".toggle_ce .toggler").on("click",function () {
        //  Options: slideToggle, fadeToggle - numeric value is animation time in ms
        $(this).closest(".toggle_ce").children(".togglebox").toggle(0, function () {
            $(this).closest(".toggle_ce").children(".toggler").toggleClass('opened');
        });
    });

    /** Tabboxenfix for nested lists **/
//TODO: Nur für Rezepte relevant? Modularisieren? Oder einfach nicht drann gehen, weil Rezepte?
    $('#nav-tabs-recipe li').on('click', function () {
        $('#nav-tabs-recipe').find('ul').find('.active').removeClass('active');
    });
    $('#nav-tabs-recipe').find('ul').children('li').on('click', function () {
        $('#nav-tabs-recipe').find('.active').removeClass('active');
    });
    /** Toggle all Toggleboxes **/
    $('#open-toggles, .open-toggles').on('click', function () {
        var currentToggle = $(this);
        if ($(this).hasClass('toggled')) {
            $(this).closest(".row").find('.toggle').each(function () {
                if ($(this).find(".icon").hasClass('icon-top_arrow')) {
                    $(this).find('header').trigger("click");
                }
                currentToggle.removeClass('toggled');
                currentToggle.text('Alles aufklappen')
            })
        }
        else {
            $(this).closest(".row").find('.toggle').each(function () {
                if ($(this).find(".icon").hasClass('icon-bottom_arrow')) {
                    $(this).find('header').trigger("click");
                }
                currentToggle.addClass('toggled');
                currentToggle.text('Alles zuklappen')
            })
        }
    });

    $('#nav-tabs-recipe').find('li').on('click', function () {
        setTimeout(function () {
            if ($('#nav-tabs-recipe li:first').hasClass('active')) {
                $('#open-toggles').show();
            }
            else {
                $('#open-toggles').hide();
            }
        }, 50);
    });
}